import { z } from 'my-zod'
import { customersModel } from './customers-model'

/**
 * This replaces the old "Customer" class on the backend
 */
export const InternalCustomerSystemView1 = customersModel.pick({
  id: true,
  firstName: true,
  lastName: true,
  gender: true,
  genderAccuracy: true,
  email: true,
  secondaryEmail: true,
  addressLine1: true,
  addressLine2: true,
  city: true,
  state: true,
  postalCode: true,
  primaryPhone: true,
  DOB: true,
  hasMotorcycleLicense: true,
  driverLicenseNumber: true,
  lastModifiedDate: true,
  createdDate: true,
  country: true
})
export type InternalCustomerSystemView1 = z.infer<typeof InternalCustomerSystemView1>
